module.exports = __webpack_public_path__ + "img/chemical.375e5bdd.png";